import { BackgroundRemoverLogo, BulbIcon, DarkModeIcon } from '../../icons'

export const WhatsNew: React.FC = () => {
	return (
		<div className='whatsnew'>
			<section className='heading'>
				<h3>What's New?</h3>
				<BulbIcon />
			</section>
			<section className='whatsnew-area'>
				<section className='background-remover-notification'>
					<section className='head'>
						<BackgroundRemoverLogo />
						<p>15.01.2021</p>
					</section>
					<section className='text-content'>
						<h3>Background Remover</h3>
						<p>
							Now you can decouple your images with background in a few clicks
							and use them in your posts.
						</p>
					</section>
					<section className='button'>
						<p>Create Project Now</p>
					</section>
				</section>
				<section className='dark-mode-notification'>
					<section className='head'>
						<DarkModeIcon />
						<p>15.01.2021</p>
					</section>
					<section className='text-content'>
						<h3>Dark Mode</h3>
						<p>
							Now you can decouple your images with background in a few clicks
							and use them in your posts.
						</p>
					</section>
					<section className='button'>
						<p>Coming Soon</p>
					</section>
				</section>
			</section>
		</div>
	)
}
